import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ReactSVG } from "react-svg";

class Accordion extends React.Component {

    state = {};

    constructor(props){
      
        super(props);

        this.header = (props.header) ? props.header : '';
        this.content = (props.content) ? props.content : '';
        this.toggleOnHeaderClick = (props.togleOnHeaderClick) ? false : true;
        this.animationType = (props.animationType) ? props.animationType : 'vertical';

        this.state.id = props.id;
        this.state.isOpen = false;
        
    }

    setExpanded(set_to)
    { 
        if (this.props.onToggle) {
            this.props.onToggle(set_to);
        }

        if (this.props.isOpen === undefined) {
            this.setState({isOpen:set_to});
        }
    }

    render(){
        const header = this.props.header || '';
        const content = this.props.content || '';
        const toggleOnHeaderClick = this.props.togleOnHeaderClick ? false : true;
        const animationType = this.props.animationType || 'vertical';
        
        const isOpen = this.props.isOpen !== undefined ? this.props.isOpen : this.state.isOpen;

        return (
            <li>
                <motion.span
                    className={isOpen ? "ac_open accordion_header" : "accordion_header"}
                    initial={false}
                    animate={{ fontWeight: isOpen ? "bold" : "normal" }}
                >
                    
                    {toggleOnHeaderClick ? <span className="header_toggle_on_click" onClick={() => this.setExpanded(isOpen ? false : this.state.id)}>{header}</span> : <>{header}</>}
                    <span className="menu_indicator" onClick={() => this.setExpanded(isOpen ? false : this.state.id)}><span className={!isOpen ? "arrow_right" : "arrow_down"}></span></span>
                </motion.span>

                <AnimatePresence initial={false}>

                    {isOpen && (
    
                        <motion.ul
                            key="content"
                            initial="collapsed"
                            animate="open"
                            exit="collapsed"
                            className="accordions_cont"
                            variants={(animationType === 'slide-right') ? 
                            {
                                open: { opacity: 1, x: 0 },
                                collapsed: { opacity: 0, x: "100%" }
                            } : {
                                open: { opacity: 1, height: "auto" },
                                collapsed: { opacity: 0, height: 0 }
                            }}
                            transition={{ duration: 0.4, ease: [0.04, 0.62, 0.23, 0.98] }}
                        >

                            {content}

                        </motion.ul>
                    )}
                </AnimatePresence>
            </li>
        );
    }
    
};

export default Accordion;
